/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Trigger from 'solis/react/trigger';


const executeDispatch = ({ client }) =>
{
  if (window.history.state == null)
  {
    client.initializeHistory();
  }
}


export default ({ ClientContext }) =>
{
  const client = use(ClientContext);

  return <Trigger client = {client} executeDispatch = {executeDispatch} />
}
